export default "__VITE_PUBLIC_ASSET__ff0d2e44__"